"use client";

import { useState } from "react";
import NewSelectInput from "../../../components/NewSelectInput";
import { Control, UseFormClearErrors } from "react-hook-form";
import { useMerchantAllListData } from "../../../apis/merchantApis";
import { IconArrowBack, IconClipboardText } from "@tabler/icons-react";
import { useLanguage } from "../../../context/LanguageContext";

type Props = {
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  clearErrors?: UseFormClearErrors<any>;
  control: Control<any>; // ✅ Add this
  reset?: any;
};

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <div className="flex items-center gap-1.5 border-b border-[#FBD037]/30 pb-1.5 mb-2">
    <div className="p-1 rounded-lg bg-[#FBD037]/20">
      <Icon size={14} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      {title}
    </p>
  </div>
);

const ReturnToShipperModal = ({
  register,
  errors,
  setValue,
  watch,
  control,
  reset,
  clearErrors,
}: Props) => {
  const { t } = useLanguage();
  const [pasteData, setPasteData] = useState("");

  const { data: clients } = useMerchantAllListData();

  return (
    <div className="w-full py-2.5   space-y-2.5 bg-white">
      <div className="space-y-2.5">
        {/* Section 1: Return Setup */}
        <div className="relative group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 border border-[#D2D2D2]/70 p-2.5 transition-all duration-300 space-y-1.5">
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconArrowBack} title={t("Return Setup")} />
          <div className="grid grid-cols-2 gap-4">
            <NewSelectInput
              className=""
              label={t("Merchant")}
              name="clientId"
              value={watch("clientId")}
              clearErrors={clearErrors}
              register={register}
              error={errors?.clientId}
              validation={{ required: "Please select Client" }}
              onChange={(val) => {
                setValue("clientId", val);
              }}
              selectOptions={
                clients?.map((client: any) => ({
                  id: client?.id,
                  value: client?.id,
                  text: client?.name,
                })) || []
              }
            />
            <NewSelectInput
              className=""
              label={t("Pickup Type")}
              name="requestType"
              value={watch("requestType")}
              clearErrors={clearErrors}
              register={register}
              error={errors?.requestType}
              validation={{ required: "Please select Pickup Type" }}
              onChange={(val) => {
                setValue("requestType", val);
              }}
              selectOptions={
                ["PICKUP", "DROPOFF"]?.map((type: any) => ({
                  id: type,
                  value: type,
                  text: type,
                })) || []
              }
            />
          </div>
        </div>

        {/* Section 2: Shipments List */}
        <div className="relative group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 border border-[#D2D2D2]/70 p-2.5 transition-all duration-300 space-y-1.5">
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconClipboardText} title={t("Shipments")} />
          <div className="w-full space-y-2">
            <textarea
              value={pasteData}
              onChange={(e) => {
                const value = e.target.value;
                setPasteData(value);
                setValue("shipments", value);
              }}
              placeholder={t("paste order ids here, separated by new lines, commas, or tabs...")}
              className="w-full h-[85px] min-h-[75px] border border-gray-200 focus:border-yellow-400 outline-none rounded-xl p-2.5 text-xs font-mono resize-none bg-white transition-colors"
              rows={3}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnToShipperModal;
